export enum ResourcePath {
	AxomoGenerateLoginToken = 'axomo_token_generator',
	CatalogItem = 'catalog_items/{id}',
	CatalogsFeatured = 'catalogs/featured',
	CatalogsGridwall = 'catalogs/gridwall',
	CompanyItemCategories = 'company_item_categories',
	CompanyItems = 'company_items',
	CurrencyConversionRate = 'conversion_rates',
	Redemptions = 'redemptions',
	ResendGiftEmail = '/rewards/{id}/resend_gift_email',
	Rewards = 'rewards',
	RewardsHistory = 'company/rewards/my_rewards',
}
